import { useEffect, useRef } from "react";

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

// Pile des panneaux ouverts : seul le dernier ouvert réagit au clavier. Sans elle, une fenêtre de
// confirmation ouverte par-dessus une autre fenêtre fermait les deux d'un seul Échap (lot 7, 30/09).
const stack = [];
let nextId = 0;

// Traps Tab/Shift+Tab focus inside containerRef while isOpen, closes on Escape,
// and restores focus to whatever had it before the panel opened.
export function useFocusTrap(containerRef, isOpen, onClose) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen) return;
    const container = containerRef.current;
    if (!container) return;
    const id = ++nextId;
    stack.push(id);
    const previouslyFocused = document.activeElement;

    const getFocusable = () =>
      Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter((el) => el.offsetParent !== null);

    // Un champ marqué data-autofocus (saisie d'un nom, d'un lien) prend la main ; sinon, le premier élément focalisable.
    (container.querySelector("[data-autofocus]") || getFocusable()[0] || container).focus();

    const handleKeyDown = (e) => {
      if (stack[stack.length - 1] !== id) return; // un panneau ouvert par-dessus a la main
      if (e.key === "Escape") { onCloseRef.current?.(); return; }
      if (e.key !== "Tab") return;
      const items = getFocusable();
      if (items.length === 0) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      const i = stack.indexOf(id);
      if (i >= 0) stack.splice(i, 1);
      previouslyFocused?.focus?.();
    };
  }, [isOpen, containerRef]);
}
